<template>
  <section>
    <v-row>
      <v-col class="px-4" cols="12">
        <v-banner two-line v-if="bot">
          <v-icon slot="icon" color="blue lighten-1" size="42">mdi-telegram</v-icon>
          <span class="title">
            Your bot's
            <b>Telegram</b> link is:
            <a
              :href="`https://t.me/${bot.username}`"
              target="_blank"
            >https://t.me/{{bot.username}}</a>
          </span>
          <br />
          <span>Share this link with those whom you want to have registered with your bot.</span>
          <template v-slot:actions>
            <v-btn
              color="primary"
              text
              @click="copy(`https://t.me/${bot.username}`)"
              v-if="canCopy"
            >Copy Link</v-btn>
          </template>
        </v-banner>
        <!--<v-progress-linear v-if="configurationLoading" top indeterminate color="primary" height="7"></v-progress-linear>-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tab" grow>
          <v-tab>Prompts</v-tab>
          <v-tab>Messages</v-tab>
          <v-tab>Geofences</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <Requirements></Requirements>
          </v-tab-item>
          <v-tab-item>
            <Messages></Messages>
          </v-tab-item>
          <v-tab-item>
            <Geofence></Geofence>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { makeFindMixin } from "feathers-vuex";
import { mapGetters, mapActions } from "vuex";

import Requirements from "@/components/registration/Requirements";
import Messages from "@/components/registration/Messages";
import Geofence from "@/components/registration/Geofence";

export default {
  data: () => ({
    tab: 0,
  }),
  mixins: [
    makeFindMixin({ service: "bots" }),
  ],
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    ...mapGetters("app", ["selectedBot"]),
    canCopy() {
      return !!navigator.clipboard;
    },
    bot() {
      return this.selectedBot || null;
    },
    botsParams() {
      return {
        query: {
          $limit: 1,
          $select: ["account_id", "first_name", "username"],
          account_id: this.user && this.user.account_id,
        },
      };
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    async copy(str) {
      await navigator.clipboard.writeText(str);
      this.showMessage({ text: "Copied to clipboard!", position: "top" });
    },
  },
  components: {
    Requirements,
    Geofence,
    Messages
  },
};
</script>